/**
 * No-FOUC theme bootstrap. Imported as a side-effecting module from `main.ts`
 * **before** any Vue mount, so the document picks up `data-theme` before
 * first paint per §15.9.J.
 *
 * Default theme is **light** (stakeholder decision 2026-05-05). Users can
 * flip to dark via the toggle; the choice persists in localStorage.
 */
const STORAGE_KEY = "ram-theme";

const stored = localStorage.getItem(STORAGE_KEY);
const initial = stored === "dark" ? "dark" : "light";
document.documentElement.setAttribute("data-theme", initial);
